/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';

import { Dialog, Paper, useMediaQuery, Tooltip, Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import axios from 'axios';
import moment from 'moment/moment';
import Draggable from 'react-draggable';
import { Link } from 'react-router-dom';
import PullToRefresh from 'react-simple-pull-to-refresh';

import ImageWrapper from 'components/ImageWrapper';
import InputNumber from 'components/Inputs/ManufactureInputs/InputNumber';
import { PrintLabel } from 'components/PrintLabel';
import ProductionDefaultImage from 'images/defaultAndEmpties/defaultAndEmptyImageRectangleNoBg.svg';
import ListIconBlue from 'images/icons/objects/clipboards/lightBlueListWhiteBgShortRoundLightBlueBorder.svg';
import PrinterDisabledIcon from 'images/icons/objects/printers/printerLightGrayOutline.svg';
import PrinterIcon from 'images/icons/objects/printers/printerYellowOutline.svg';
import CheckedCircleIcon from 'images/icons/signals/checks/checkWhiteGreenBgRoundedNavyBorder.svg';
import CancelProduction from 'images/icons/signals/closesAndCancels/cancelWhiteRedBgRoundedNavyBorder.svg';
import deleteWhite from 'images/icons/signals/closesAndCancels/closeWhiteNavyGrayBgRounded.svg';
import PauseProductionIcon from 'images/icons/signals/pausesAndStops/pauseWhiteYellowMustardBgRoundedNavyBorder.svg';
import PlayIcon from 'images/icons/signals/playsAndStarts/playWhiteNavyBlueBgRoundedNavyBorder.svg';
import ClockGreenIcon from 'images/icons/objects/clocks/clockColoredLightGreenBgRounded.svg';
import ClockGreenDisabledIcon from 'images/icons/objects/clocks/clockLightGreenNoBgLightGreenBorderRounded.svg';
import Environment from 'utils/environments';
import { increaseDate } from 'utils/formatDate';
import numberToReal from 'utils/numberToReal';
import ValidationLength from 'utils/utils';

import MobileCardDetail from './ProductionDialog/index';
import {
  CardsContainer,
  CardTitleWrapper,
  CardInfoHeader,
  CardPlayWrapper,
  CardContainer,
  CardInfoContent,
  CardContentTitle,
  CardContentElement,
  ProductionPlay,
  ProductionLabel,
  CardModal
} from './style';
import { setPopoverDataStatus } from './utils';

import { handleFields, getProductionCardStatus } from '../utils';
import ProductionIcon from 'images/icons/objects/bells/productionIcon';
import GearRoundedIcon from 'images/icons/configsAndSetups/gearRoundedIcon';
import AlertRoundedIcon from 'images/icons/signals/alerts/alertRoundedIcon';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-card-production-dialog"
      cancel='[class*="MuiDialogContent-root"]'
    >
      <Paper {...props} />
    </Draggable>
  );
}

function MobileCard({
  setCurrentCard,
  handleUpdateViewMethod,
  handleItemDiscard,
  setModalStates,
  mainModalStates,
  updateQuantityInitialValue,
  manufactures,
  setManufactures,
  originId,
  setCurrentTransformationCardItems,
  setManufacture,
  index,
  description,
  state,
  manufactureYield,
  newDuration,
  limitProd,
  manufactureQuantity,
  manufactureTotalYield,
  manufactureStatus,
  dateStatus,
  items,
  actions,
  manufacture,
  optionsDiscard,
  manufactureStock,
  manufactureDuration,
  lossManufactured,
  manufactured,
  totalItemsQuantity,
  cardYield,
  type,
  optionsCards,
  setCardDate,
  forceEnable,
  setForceEnable,
  stores,
  companyActive,
  companyGroup,
  parametersInfos,
  handlePrintPortion,
  modalSettings,
  setModalSettings,
  userInfo
}) {
  const environments = Environment(process.env.REACT_APP_ENV);
  const StatusIcon = getProductionCardStatus(userInfo?.whiteLabel)[
    manufactureStatus
  ]?.renderIcon;
  const isChinaWhiteLabel = userInfo?.whiteLabel === 'CHINA';
  const [openDrillDown, setOpenDrillDown] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [transformationInfos, setTransformationInfos] = useState();
  const isPhone = useMediaQuery('(max-width: 767px)');
  const isTransformation = manufacture?.type === 'TRANSFORMATION';
  const isPrintEnabled =
    parametersInfos?.manufactures?.isPrintEnabled &&
    manufacture?.status !== 'CANCELED';
  const manufactureStatusAction = manufacture.actions?.filter(
    (item) => item.type === 'START'
  );
  const haveSomePrintLabel = isTransformation
    ? manufacture?.items
        ?.map((item) => item?.portions?.some((portion) => portion?.printed))
        .flat()
        ?.some((el) => el)
    : manufacture?.portions?.some((el) => el?.printed);
  const manufactureDefaultStartAction = [
    {
      date: manufacture?.created_at
    }
  ];
  const manufactureStartActionsOrdered = manufactureStatusAction?.length
    ? manufactureStatusAction
    : manufactureDefaultStartAction?.sort((a, b) => (a.date > b.date ? 1 : -1));

  const manufactureFinishActionsOrdered =
    manufacture.actions
      ?.filter((item) => item.type === 'FINISH')
      ?.sort((a, b) => (a.date > b.date ? 1 : -1)) || [];

  const manufacturePauseActionsOrdered =
    manufacture.actions
      ?.filter((item) => item.type === 'PAUSE')
      ?.sort((a, b) => (a.date > b.date ? 1 : -1)) || [];

  const manufactureCanceledActionsOrdered =
    manufacture?.actions?.find((action) => action?.type === 'CANCELED')?.date ||
    new Date();

  const cardIconByStatus = (status, hasPortions) => {
    if (status === 'CANCELED') {
      return <img src={CancelProduction} />;
    }

    if (status === 'WAITING') {
      return <img src={PlayIcon} />;
    }

    if (status === 'START') {
      return (
        <ProductionIcon
          bgColor={userInfo?.whiteLabel === 'CHINA' ? '#086391' : '#5062F0'}
        />
      );
    }

    if (status === 'PAUSE') {
      return <img src={PauseProductionIcon} />;
    }

    if (status === 'FINISH' && isPrintEnabled) {
      if (hasPortions) return <img src={ClockGreenIcon} />;

      return <img src={ClockGreenDisabledIcon} />;
    }

    if (status === 'FINISH' && !isPrintEnabled) {
      return <img src={CheckedCircleIcon} />;
    }
  };

  const handleOpenModal = () => {
    if (isTransformation) {
      axios
        .get(
          `${environments.catalog}/products/manufactures/transformation/${manufacture?.productId}?originId=${originId}`
        )
        .then((response) => {
          setTransformationInfos(response?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }

    setManufacture(manufacture);
    setCurrentTransformationCardItems(manufacture);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setForceEnable(false);
    setTransformationInfos();
  };

  const handleDeleteButton = () => {
    const { deleteButton } = actions;
    deleteButton.handleDialogClickOpen();
    deleteButton.setDeleteData(manufacture);
  };

  const handleStatusButton = (e) => {
    const { statusButton } = actions;
    const { type, status } = manufacture;
    statusButton.setManufacture(manufacture);
    setManufacture(manufacture);
    setCurrentTransformationCardItems({
      ...manufacture,
      items: manufacture?.items?.map((el) => ({
        ...el,
        quantity: null
      }))
    });
    statusButton.setPopoverData(setPopoverDataStatus(type, status));
    statusButton.handlePopoverClick(e, { isMobile: true });
  };

  const handleQuantity = (value) => {
    actions.handleCardQuantity(
      index,
      parseFloat(value.replace(',', '.')),
      undefined,
      undefined,
      undefined
    );
  };

  const handleQuantityField = (status, value, type) =>
    value
      ? parseFloat(value).toLocaleString('pt-br', { minimumFractionDigits: 3 })
      : '0,000';

  const performance = handleQuantityField(
    manufacture.status,
    manufacture.initialYield ||
      manufacture.status === 'FINISH' ||
      manufacture.status === 'CANCELED'
      ? manufacture.yield
      : type.toLowerCase() === 'recipe'
      ? manufacture.yield
      : (manufacture.quantity || 1) -
        (manufacture.quantity || 1) * (manufacture.loss / 100),
    'yield'
  );

  const produced =
    manufacture.status === 'FINISH' && manufacture?.manufactured !== null
      ? `${manufacture.manufactured?.toLocaleString('pt-br', {
          minimumFractionDigits: 3
        })}`
      : manufacture.status === 'FINISH'
      ? handleFields(manufacture).manufactured
      : null;

  const total = manufacture.items.reduce(
    (total, value) =>
      value
        ? parseFloat(total) + parseFloat(value.quantity)
        : parseFloat(total),
    0
  );

  const lossManufacturedCalc = manufacture?.manufactured - manufacture?.yield;

  const handlePreparationClick = (url) => {
    const encodedUrl = btoa(url);
    localStorage.setItem('preparationUrl', encodedUrl);
  };

  useEffect(() => {
    setTimeout(() => {
      if (openModal && document?.querySelector('#yieldCardField input')) {
        document?.querySelector('#yieldCardField input')?.select();
      }
    }, 100);
  }, [openModal, optionsCards]);

  return (
    <CardsContainer type={type}>
      {/* <ProductionLabel
        style={{
          borderRadius: '4px 4px 0px 0px',
          padding: '0px',
          height: '4px'
        }}
        backgroundColor={getProductionCardStatus(userInfo?.whiteLabel)[manufactureStatus]?.statusColor}
      /> */}

      <CardTitleWrapper
        backgroundColor={
          getProductionCardStatus(userInfo?.whiteLabel)[manufactureStatus]
            ?.statusColor
        }
        isChinaWhiteLabel={isChinaWhiteLabel}
      >
        {StatusIcon?.$$typeof ? (
          <StatusIcon
            id="MobilePlayProductionButton"
            disabled={
              manufacture.status === 'FINISH' ||
              manufacture.status === 'CANCELED'
            }
            style={{ color: '#000', width: '25px', height: '25px' }}
          />
        ) : (
          <>
            <div
              className="dFlex alignCenter justifyCenter pRelative cardImageBox"
              style={{
                border: `2px solid ${
                  type === 'RECIPE' ? '#1D8FC9' : '#F2B90D'
                }`,
                width: '32%',
                height: 80,
                zIndex: 1,
                background: '#FFF'
              }}
            >
              <ImageWrapper
                width="100%"
                height="100%"
                url={
                  isTransformation
                    ? manufacture?.itemTransformation?.image?.url ||
                      ProductionDefaultImage
                    : manufacture?.image || ProductionDefaultImage
                }
                borderType={manufacture?.type}
                disablePortal={false}
              />
            </div>

            {/* <ProductionPlay
              marginRight="0px"
              src={StatusIcon}
              onClick={handleOpenModal}
              // onClick={manufacture.status === "FINISH" || manufacture.status === "CANCELED" ? null : handleStatusButton}
              id="MobilePlayProductionButton"
              style={{
                boxShadow: '5px 5px 4px rgba(0, 0, 0, 0.3)',
                position: 'absolute',
                left: '7.5px'
              }}
            /> */}
          </>
        )}

        <div
          className="dFlex flexColumn"
          style={{
            width: '68%',
            padding: '3px 5px',
            background:
              type === 'RECIPE'
                ? 'rgba(29, 143, 201, .5)'
                : 'rgba(242, 185, 13, .5)'
          }}
        >
          <div className="dFlex alignEnd">
            <div
              className="dFlex justifyCenter alignCenter mr5"
              style={{
                width: '40%',
                background: type === 'RECIPE' ? '#086391' : '#AA8208',
                borderRadius: '20px',
                height: 25
              }}
            >
              <p
                style={{
                  fontSize: 12,
                  color: '#FFF'
                }}
                className="mb0 bold uppercase"
              >
                {type === 'RECIPE' ? `RECEITA` : 'TRANSF.'}
              </p>
            </div>

            <div
              className="dFlex"
              style={{
                width: '60%',
                justifyContent: 'flex-end'
              }}
            >
              <div className="dFlex">
                {isPrintEnabled && haveSomePrintLabel ? (
                  <div className="printLabelMobileBox bgWhite dFlex alignCenter justifyCenter">
                    <img
                      onClick={() => {
                        if (!haveSomePrintLabel) return;

                        setModalSettings(
                          modalSettings.map((modal) =>
                            modal.name === 'confirmPrint'
                              ? {
                                  ...modal,
                                  open: true,
                                  currentManufacture: manufacture
                                }
                              : modal
                          )
                        );
                      }}
                      className={
                        haveSomePrintLabel ? 'cursorPointer' : 'cursorAuto'
                      }
                      src={
                        haveSomePrintLabel ? PrinterIcon : PrinterDisabledIcon
                      }
                      style={{ width: '20px' }}
                      alt="PrinterIcon"
                    />
                  </div>
                ) : null}

                {manufacture?.preparationMethod?.url ? (
                  <Link
                    to={`/preparation/${manufacture?.preparationMethod?.name}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      style={{
                        width: 25,
                        marginRight: '3px',
                        marginLeft: 10
                      }}
                      src={ListIconBlue}
                      alt="Preparation Method"
                      onClick={() =>
                        handlePreparationClick(
                          manufacture?.preparationMethod?.url
                        )
                      }
                    />
                  </Link>
                ) : null}

                <Grid
                  style={{
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {manufacture.origin === 'M' ? (
                    <Tooltip
                      title={
                        <div style={{ padding: '4px' }}>
                          <p style={{ margin: '0' }}>
                            Produção fora da programação
                          </p>
                        </div>
                      }
                      aria-label="filters"
                      placement="right-start"
                      enterTouchDelay={0}
                    >
                      <AlertRoundedIcon
                        size={25}
                        variant="primary"
                        style={{ marginLeft: 15 }}
                        title="Produção fora da programação"
                        borderColor={isChinaWhiteLabel && '#454A67'}
                      />
                    </Tooltip>
                  ) : manufacture?.engine?.quantity ? (
                    <Tooltip
                      title={
                        <p style={{ padding: '3px 8px', margin: 0 }}>
                          <b>Sugestão Copiloto:</b>
                          <br />
                          <b>Qtde de acordo com a sugestão</b>
                        </p>
                      }
                      aria-label="filters"
                      placement="right-start"
                      enterTouchDelay={0}
                    >
                      <GearRoundedIcon
                        size={25}
                        variant="primary"
                        style={{ marginLeft: 15 }}
                        frameColor={isChinaWhiteLabel && '#454A67'}
                        strokeColor={isChinaWhiteLabel && '#454A67'}
                      />
                    </Tooltip>
                  ) : (
                    <Tooltip
                      title={
                        <p style={{ padding: '3px 8px', margin: 0 }}>
                          <b>Sugestão Copiloto:</b>
                          <br />
                          <b>Qtde sugerida alterada pelo usuário</b>
                        </p>
                      }
                      aria-label="filters"
                      placement="right-start"
                      enterTouchDelay={0}
                    >
                      <GearRoundedIcon
                        size={25}
                        variant="muted"
                        style={{ marginLeft: 15 }}
                      />
                    </Tooltip>
                  )}
                </Grid>
              </div>

              <img
                style={{
                  marginLeft: 10,
                  width: 25,
                  height: 25
                }}
                src={deleteWhite}
                alt="DeleteWhite"
                onClick={() => {
                  if (manufacture.status === 'CANCELED') return;

                  handleDeleteButton();
                }}
                id="MobileDeleteCard"
              />
            </div>
          </div>

          <span
            className="childTdFontSize16"
            style={{
              color: '#010311',
              fontWeight: 'bold',
              fontSize: isPhone ? '14px' : '16px',
              lineHeight: 1.2
            }}
            onClick={handleOpenModal}
          >
            {ValidationLength(description, 45)}
          </span>
        </div>
      </CardTitleWrapper>

      <CardInfoHeader
        style={{ display: 'flex', flexDirection: 'row' }}
        onClick={handleOpenModal}
      >
        {manufactureStatus !== 'FINISH' ? (
          <CardInfoContent width="31%">
            <CardContentTitle
              className="mb2"
              style={{
                fontSize: 10,
                lineHeight: '12px',
                color: '#010311'
              }}
            >
              QUANTIDADE
            </CardContentTitle>

            <CardContentElement
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                width: '81px'
              }}
            >
              <InputNumber
                minimumValue="0"
                maximumValue="999999999"
                initialValue={parseFloat(manufactureQuantity).toFixed(3)}
                disabled
                handleValue={handleQuantity}
                updateQuantityInitialValue={updateQuantityInitialValue}
              />
            </CardContentElement>
          </CardInfoContent>
        ) : (
          <CardInfoContent width={isPhone ? '25%' : '35%'}>
            <CardContentTitle
              className="mb2"
              style={{
                fontSize: 10,
                lineHeight: '12px',
                textAlign: 'end',
                color: '#010311',
                width: manufacture.status === 'FINISH' ? '100%' : 'auto'
              }}
            >
              RENDIMENTO
            </CardContentTitle>

            <CardContentElement
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                width: manufacture.status === 'FINISH' ? '100%' : 'auto'
              }}
            >
              <div
                className="bold"
                style={{ fontSize: isPhone ? '12px' : '16px' }}
              >
                {handleQuantityField(
                  manufacture.status,
                  type === 'RECIPE' ||
                    manufacture?.status === 'FINISH' ||
                    manufacture?.status === 'CANCELED'
                    ? manufacture.yield
                    : (manufacture.quantity || 1) -
                        (manufacture.quantity || 1) * (manufacture.loss / 100),
                  'yield'
                )}
              </div>

              <span
                className="bold"
                style={{
                  fontSize: isPhone ? '12px' : '16px',
                  lineHeight: '20px',
                  color: '#010311'
                }}
              >
                {manufacture?.un?.abbreviation || ''}
              </span>
            </CardContentElement>
          </CardInfoContent>
        )}

        {!openDrillDown && manufactureStatus !== 'FINISH' ? (
          <CardInfoContent
            width={manufacture.status === 'FINISH' ? '45%' : '35%'}
            style={{
              marginLeft: manufacture.status === 'FINISH' ? '28px' : null
            }}
          >
            <CardContentTitle
              className="mb2"
              style={{
                fontSize: 10,
                lineHeight: '12px',
                textAlign: 'end',
                color: '#010311',
                width: manufacture.status === 'FINISH' ? '100%' : 'auto'
              }}
            >
              RENDIMENTO{manufacture.status === 'FINISH' ? '/PRODUZIDO' : null}
            </CardContentTitle>

            <CardContentElement
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                width: manufacture.status === 'FINISH' ? '100%' : 'auto'
              }}
            >
              <div
                className="bold"
                style={{ fontSize: isPhone ? '12px' : '16px' }}
              >
                {handleQuantityField(
                  manufacture.status,
                  type === 'RECIPE' ||
                    manufacture?.status === 'FINISH' ||
                    manufacture?.status === 'CANCELED'
                    ? manufacture.yield
                    : (manufacture.quantity || 1) -
                        (manufacture.quantity || 1) * (manufacture.loss / 100),
                  'yield'
                )}

                <span
                  className="bold"
                  style={{
                    color:
                      manufacture.status !== 'FINISH'
                        ? '#010311'
                        : lossManufacturedCalc < 0
                        ? '#F53D4C'
                        : lossManufacturedCalc == 0
                        ? '#0E1337'
                        : '#664C00'
                  }}
                >
                  {produced}
                </span>
              </div>

              <span
                className="bold"
                style={{
                  fontSize: isPhone ? '12px' : '16px',
                  lineHeight: '20px',
                  color:
                    manufacture.status !== 'FINISH'
                      ? '#010311'
                      : lossManufacturedCalc < 0
                      ? '#F53D4C'
                      : lossManufacturedCalc === 0
                      ? '#0E1337'
                      : '#664C00'
                }}
              >
                {manufacture?.un?.abbreviation || ''}
              </span>
            </CardContentElement>
          </CardInfoContent>
        ) : (
          <CardInfoContent width="35%">
            <CardContentTitle
              className="mb2"
              style={{
                fontSize: 10,
                lineHeight: '12px',
                textAlign: 'end',
                color: '#010311',
                width: manufacture.status === 'FINISH' ? '100%' : 'auto'
              }}
            >
              PRODUZIDO
            </CardContentTitle>

            <CardContentElement
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                width: manufacture.status === 'FINISH' ? '100%' : 'auto'
              }}
            >
              <div
                className="bold"
                style={{ fontSize: isPhone ? '12px' : '16px' }}
              >
                <span
                  className="bold"
                  style={{
                    color:
                      manufacture.status !== 'FINISH'
                        ? '#010311'
                        : lossManufacturedCalc < 0
                        ? '#F53D4C'
                        : lossManufacturedCalc == 0
                        ? '#0E1337'
                        : '#664C00'
                  }}
                >
                  {produced}
                </span>
              </div>

              <span
                className="bold"
                style={{
                  fontSize: isPhone ? '12px' : '16px',
                  lineHeight: '20px',
                  color:
                    manufacture.status !== 'FINISH'
                      ? '#010311'
                      : lossManufacturedCalc < 0
                      ? '#F53D4C'
                      : lossManufacturedCalc === 0
                      ? '#0E1337'
                      : '#664C00'
                }}
              >
                {manufacture?.un?.abbreviation || ''}
              </span>
            </CardContentElement>
          </CardInfoContent>
        )}

        <CardInfoContent
          width="45%"
          style={{ display: 'none' }}
          open={!openDrillDown}
        >
          <CardContentTitle
            className="mb2"
            style={{
              fontSize: 10,
              lineHeight: '12px',
              color: '#010311'
            }}
          >
            ESTOQUE/DURAÇÃO
          </CardContentTitle>

          <CardContentElement className="bold">
            {numberToReal(manufactureStock)} / {manufactureDuration} dias
          </CardContentElement>
        </CardInfoContent>

        <CardInfoContent
          className="limitProdCard"
          style={{ display: 'none' }}
          width="26.5%"
        >
          <CardContentTitle
            className="mb2"
            style={{
              fontSize: 10,
              lineHeight: '12px',
              color: '#010311'
            }}
          >
            LIMITE PROD.
          </CardContentTitle>

          <CardContentElement className="bold" backGroundOn>
            {limitProd || '-----'}
          </CardContentElement>
        </CardInfoContent>

        <CardInfoContent className="limitProdCard" width="26.5%">
          <CardContentTitle
            className="mb2"
            style={{
              fontSize: 10,
              lineHeight: '12px',
              textAlign: 'end',
              color: '#010311'
            }}
          >
            DATA
          </CardContentTitle>

          <CardContentElement
            style={{ display: 'flex', justifyContent: 'flex-end' }}
          >
            <div
              className="bold"
              style={{
                fontSize: isPhone ? '12px' : '16px',
                lineHeight: '20px'
              }}
            >
              {moment(manufacture.date)?.add(3, 'hours').format('DD/MM/YY')}
            </div>
          </CardContentElement>
        </CardInfoContent>
      </CardInfoHeader>

      <CardInfoHeader
        className={`openedInfoHeader ${!openDrillDown && 'p2 pb0'}`}
      >
        {openDrillDown && (
          <CardInfoContent className="yieldAndNewDurationCard" width="35%">
            <CardContentTitle
              className="mb2"
              style={{
                fontSize: 10,
                lineHeight: '12px',
                textAlign: 'end'
              }}
            >
              RENDIMENTO
            </CardContentTitle>

            <CardContentElement
              style={{ display: 'flex', justifyContent: 'end' }}
            >
              <div
                className="bold"
                style={{ fontSize: isPhone ? '12px' : '16px' }}
              >
                {performance}
              </div>

              <span className="bold">
                {manufacture?.un?.abbreviation || ''}
              </span>
            </CardContentElement>
          </CardInfoContent>
        )}

        <CardInfoContent
          className="lossAndProducedCard"
          width="50%"
          open={!openDrillDown}
        >
          <CardContentTitle
            className="mb2"
            style={{ fontSize: 10, lineHeight: '12px' }}
          >
            PERDA/PRODUZIDO
          </CardContentTitle>

          <CardContentElement>
            {numberToReal(lossManufactured)} /
            <span
              className="bold"
              style={{
                color:
                  manufactureQuantity && totalItemsQuantity
                    ? parseFloat(manufactureQuantity) - parseFloat(cardYield) <
                      parseFloat(manufactureQuantity) -
                        parseFloat(totalItemsQuantity)
                      ? '#F53D4C'
                      : '#010311'
                    : '#010311'
              }}
            >
              {numberToReal(manufactured)}{' '}
              {isTransformation
                ? manufacture?.items?.[0]?.un?.abbreviation
                : manufacture?.abbreviation}
            </span>
            <span
              className="bold"
              style={{
                marginLeft: 10,
                color:
                  parseFloat(100 * (manufactureQuantity - totalItemsQuantity)) /
                    parseFloat(manufactureQuantity) >
                  parseFloat(lossManufactured)
                    ? '#F53D4C'
                    : '#010311'
              }}
            >
              {totalItemsQuantity === 0 ? (
                <>&nbsp;</>
              ) : (
                <>
                  {`${(
                    parseFloat(
                      100 * (manufactureQuantity - totalItemsQuantity)
                    ) / parseFloat(manufactureQuantity)
                  ).toLocaleString('pt-br', { minimumFractionDigits: 3 })}%`}
                </>
              )}
            </span>
          </CardContentElement>
        </CardInfoContent>
      </CardInfoHeader>

      <CardPlayWrapper onClick={handleOpenModal} style={{ marginTop: '0px' }}>
        <ProductionLabel
          backgroundColor={
            getProductionCardStatus(userInfo?.whiteLabel)[manufactureStatus]
              ?.borderBackgroundColor
          }
          fontColor={
            getProductionCardStatus(userInfo?.whiteLabel)[manufactureStatus]
              ?.labelStatusColor
          }
          justifyContent="flex-start"
        >
          {cardIconByStatus(manufacture?.status, manufacture?.hasPortions)}

          <div
            className="bold uppercase"
            style={{ fontSize: isPhone ? '14px' : '16px' }}
          >
            {`${
              getProductionCardStatus(userInfo?.whiteLabel)[manufactureStatus]
                ?.statusText
            }`}
          </div>

          {manufacture?.cancellationReason && (
            <span
              className="dFlex bold uppercase"
              style={{ marginLeft: 5, fontSize: isPhone ? '14px' : '16px' }}
            >
              <span style={{ marginRight: 4 }}> - </span>{' '}
              {ValidationLength(manufacture?.cancellationReason, 20)}
            </span>
          )}

          {dateStatus && (
            <div
              className="bold"
              style={{
                margin: '0 0 0 auto',
                fontSize: isPhone ? '14px' : '12px'
              }}
            >
              {manufacture.status === 'START' && 'INICIADO'}
              {manufacture.status === 'FINISH' &&
                manufactureStartActionsOrdered.length &&
                moment(
                  new Date(manufactureStartActionsOrdered[0]?.date)
                ).format('LT')}{' '}
              às{' '}
              {manufacture.status === 'START' &&
                manufactureStartActionsOrdered.length &&
                moment(
                  new Date(manufactureStartActionsOrdered[0]?.date)
                ).format('LT')}{' '}
              {manufacture.status === 'FINISH' &&
                manufactureFinishActionsOrdered.length &&
                moment(
                  new Date(manufactureFinishActionsOrdered[0]?.date)
                ).format('LT')}{' '}
              {manufacture?.status === 'PAUSE' &&
                manufacturePauseActionsOrdered?.length &&
                moment(
                  new Date(manufacturePauseActionsOrdered[0]?.date)
                ).format('LT')}{' '}
              {manufacture?.status === 'CANCELED' &&
                manufactureCanceledActionsOrdered &&
                moment(manufactureCanceledActionsOrdered).format('LT')}{' '}
              {dateStatus.user ? `(${dateStatus.user})` : ''}
            </div>
          )}
        </ProductionLabel>
      </CardPlayWrapper>

      <CardInfoContent>
        {!isTransformation || transformationInfos ? (
          <Dialog
            className="modalProducao"
            open={openModal}
            fullWidth
            maxWidth="sm"
            onClose={handleCloseModal}
            PaperComponent={PaperComponent}
          >
            <CardModal cardType={manufacture?.type}>
              <MobileCardDetail
                userInfo={userInfo}
                setCurrentCard={setCurrentCard}
                handleUpdateViewMethod={handleUpdateViewMethod}
                handleItemDiscard={handleItemDiscard}
                setCurrentTransformationCardItems={
                  setCurrentTransformationCardItems
                }
                forceEnable={forceEnable}
                updateQuantityInitialValue={updateQuantityInitialValue}
                setModal={setModalStates}
                mainModalStates={mainModalStates}
                setCardDate={setCardDate}
                manufactures={manufactures}
                setManufactures={setManufactures}
                isOpen={openModal}
                transformationInfos={transformationInfos}
                index={index}
                description={description}
                state={state}
                manufactureYield={manufactureYield}
                newDuration={newDuration}
                limitProd={limitProd}
                manufactureQuantity={manufactureQuantity}
                manufactureTotalYield={manufactureTotalYield}
                manufactureStatus={manufactureStatus}
                dateStatus={dateStatus}
                items={items}
                actions={actions}
                manufacture={manufacture}
                optionsDiscard={optionsDiscard}
                manufactureStock={manufactureStock}
                manufactureDuration={manufactureDuration}
                lossManufactured={lossManufactured}
                manufactured={manufactured}
                totalItemsQuantity={totalItemsQuantity}
                cardYield={cardYield}
                type={type}
                loss={manufacture.loss}
                income={performance}
                handlePreparationClick={handlePreparationClick}
                handleDeleteButton={handleDeleteButton}
                cardIconByStatus={cardIconByStatus}
                parametersInfos={parametersInfos}
                handlePrintPortion={handlePrintPortion}
                modalSettings={modalSettings}
                setModalSettings={setModalSettings}
              />
            </CardModal>
          </Dialog>
        ) : null}
      </CardInfoContent>
    </CardsContainer>
  );
}

function MobileProductionCards({
  setCurrentCard,
  handleUpdateViewMethod,
  handleItemDiscard,
  setModal,
  mainModalStates,
  updateQuantityInitialValue,
  originId,
  setCurrentTransformationCardItems,
  setManufacture,
  manufactures,
  setManufactures,
  state,
  optionsDiscard,
  actions,
  loadingMainList,
  loading,
  optionsCards,
  setCardDate,
  forceEnable,
  setForceEnable,
  stores,
  companyActive,
  companyGroup,
  parametersInfos,
  handlePrintPortion,
  modalSettings,
  setModalSettings,
  userInfo
}) {
  const { cards } = state;

  const loadingCard = () => (
    <CardsContainer className="loading-card">
      <div className="div-loading-title-btnPlay">
        <Skeleton variant="rect" width="44px" height="44px" />
        <Skeleton variant="rect" width="85%" height="22px" />
      </div>

      <div className="div-loading-status">
        <Skeleton variant="rect" width="100%" height="32px" />
      </div>

      <div className="div-loading-info">
        <div className="div-loading-quantity">
          <Skeleton
            variant="rect"
            width="100%"
            height="12px"
            className="loading-info-title"
          />
          <Skeleton variant="rect" width="100%" height="20px" />
        </div>

        <div className="div-loading-yield">
          <Skeleton
            variant="rect"
            width="100%"
            height="12px"
            className="loading-info-title"
          />
          <Skeleton variant="rect" width="100%" height="20px" />
        </div>

        <div className="div-loading-date">
          <Skeleton
            variant="rect"
            width="100%"
            height="12px"
            className="loading-info-title"
          />
          <Skeleton variant="rect" width="100%" height="20px" />
        </div>
      </div>
    </CardsContainer>
  );

  return (
    <PullToRefresh
      className="customPullToRefresh"
      onRefresh={() =>
        new Promise(() => {
          setTimeout(() => {
            window.location.reload();
          }, 500);
        })
      }
    >
      <CardContainer>
        {manufactures.map((manufacture, index) => {
          const {
            description,
            _id,
            quantity,
            status,
            items,
            stock,
            duration,
            loss,
            manufactured,
            type,
            date
          } = manufacture;
          const fields = handleFields(manufacture);
          const dateStatus =
            status === 'CANCELED'
              ? manufacture?.actions?.find(
                  (el) => el?.type === status && el?.type !== 'WAITING'
                )
              : manufacture.actions.find(
                  (el) => el.type === status && el.type !== 'WAITING'
                );
          const exists = cards ? cards.find((x) => x?.id === index) : null;

          if (cards && cards.length < manufactures.length && !exists) {
            cards.push({
              id: index,
              open: false,
              quantity: manufacture.quantity,
              type: type.toLowerCase(),
              startTime: manufacture.actions
                .reverse()
                .find((x) => x.type === 'START')
                ? manufacture.actions.reverse().find((x) => x.type === 'START')
                    .date
                : null,
              pauseTime: manufacture.actions
                .reverse()
                .find((x) => x.type === 'PAUSE')
                ? manufacture.actions.reverse().find((x) => x.type === 'PAUSE')
                    .date
                : null,
              finishTime: manufacture.actions
                .reverse()
                .find((x) => x.type === 'FINISH')
                ? manufacture.actions.reverse().find((x) => x.type === 'FINISH')
                    .date
                : null,
              manufactured: manufacture.manufactured,
              totalLoss: null,
              loss: manufacture.loss ? manufacture.loss : 0,
              totalYield:
                type.toLowerCase() === 'recipe'
                  ? manufacture.yield * 1
                  : 1 - 1 * (manufacture.loss / 100),
              initialYield:
                type.toLowerCase() === 'recipe'
                  ? manufacture.yield * 1
                  : 1 - 1 * (manufacture.loss / 100),
              items: []
            });
          }

          const cardYield =
            manufacture.type === 'recipe'
              ? manufacture.yield * (manufacture.quantity || 1)
              : (manufacture.quantity || 1) -
                (manufacture.quantity || 1) * (manufacture.loss / 100);
          const total = manufacture.items.reduce(
            (total, value) =>
              value
                ? parseFloat(total) + parseFloat(value.quantity)
                : parseFloat(total),
            0
          );

          return (
            <>
              {!loadingMainList ? (
                <MobileCard
                  handleUpdateViewMethod={handleUpdateViewMethod}
                  setCurrentCard={setCurrentCard}
                  handleItemDiscard={handleItemDiscard}
                  forceEnable={forceEnable}
                  setForceEnable={setForceEnable}
                  updateQuantityInitialValue={updateQuantityInitialValue}
                  setModalStates={setModal}
                  mainModalStates={mainModalStates}
                  setCardDate={setCardDate}
                  manufactures={manufactures}
                  setManufactures={setManufactures}
                  originId={originId}
                  setCurrentTransformationCardItems={
                    setCurrentTransformationCardItems
                  }
                  setManufacture={setManufacture}
                  index={index}
                  key={_id}
                  id={`MobileProductionCard${_id}`}
                  description={description}
                  state={state}
                  manufactureYield={fields.manufactureYield}
                  newDuration={fields.newDuration}
                  limiteProd={fields.manufactureLimit}
                  manufactureQuantity={manufacture.quantity || 1}
                  manufactureTotalYield={
                    manufacture.initialYield
                      ? manufacture.yield
                      : type.toLowerCase() === 'recipe'
                      ? manufacture.yield * (manufacture.quantity || 1)
                      : (manufacture.quantity || 1) -
                        (manufacture.quantity || 1) * (manufacture.loss / 100)
                  }
                  manufactureStatus={status}
                  manufactureStock={stock}
                  manufactureDuration={duration}
                  lossManufactured={loss}
                  manufactured={
                    (manufacture.quantity || 1) && total
                      ? (
                          parseFloat(manufacture.quantity || 1) -
                          parseFloat(total)
                        ).toLocaleString('pt-br', { minimumFractionDigits: 3 })
                      : (
                          parseFloat(manufacture.quantity || 1) -
                          parseFloat(cardYield)
                        ).toLocaleString('pt-br', { minimumFractionDigits: 3 })
                  }
                  type={type}
                  dateStatus={dateStatus}
                  items={items}
                  actions={actions}
                  manufacture={manufacture}
                  optionsDiscard={optionsDiscard}
                  parametersInfos={parametersInfos}
                  handlePrintPortion={handlePrintPortion}
                  modalSettings={modalSettings}
                  setModalSettings={setModalSettings}
                  totalItemsQuantity={total}
                  cardYield={cardYield}
                  optionsCards={optionsCards}
                  stores={stores}
                  companyActive={companyActive}
                  companyGroup={companyGroup}
                  userInfo={userInfo}
                />
              ) : (
                loadingCard()
              )}
            </>
          );
        })}
      </CardContainer>
    </PullToRefresh>
  );
}

export default MobileProductionCards;
